import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '外部项目组织单元',
    type: 'OU_1',
}
